import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiClock, FiMail, FiMapPin, FiPhone } from 'react-icons/fi';
import PagesTopNav from "../components/TopNav/PagesTopNav";
import PageLayout from "../components/PageLayout";
import './contact.css';

const ADDRESS = ['Plot 22211, Nshaiwa Street, Phase 4', 'Gaborone, Botswana'];
const PHONE = '+267 76 350 228';
const EMAIL = 'info@nnetego.com';
const HOURS = 'Mon–Fri, 8am–5pm CAT';
const MAP_URL = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(ADDRESS.join(', '))}`;

const ContactUsPage = () => (
  <div>
    <PagesTopNav />
    <PageLayout title="Contact Us" description="Get in touch with our team for any inquiries or support">
      <p className="contact-intro">
        Get in touch with us for any inquiries, support, or partnership opportunities regarding our hotel management solutions. Our
        Botswana-based team is ready to assist you.
      </p>

      <div className="contact-grid">
        <article className="contact-card">
          <span className="contact-icon" aria-hidden="true">
            <FiMapPin />
          </span>
          <h3>Our location</h3>
          {ADDRESS.map((line) => (
            <p key={line}>{line}</p>
          ))}
          <a className="contact-action" href={MAP_URL} target="_blank" rel="noopener noreferrer">
            View on map <FiArrowRight />
          </a>
        </article>

        <article className="contact-card">
          <span className="contact-icon" aria-hidden="true">
            <FiPhone />
          </span>
          <h3>Phone</h3>
          <p>
            <a className="contact-link" href="tel:+26776350228">
              {PHONE}
            </a>
          </p>
          <p className="contact-hours">
            <FiClock aria-hidden="true" /> {HOURS}
          </p>
          <a className="contact-action" href="tel:+26776350228">
            Call us <FiArrowRight />
          </a>
        </article>

        <article className="contact-card">
          <span className="contact-icon" aria-hidden="true">
            <FiMail />
          </span>
          <h3>Email</h3>
          <p>
            <a className="contact-link" href={`mailto:${EMAIL}`}>
              {EMAIL}
            </a>
          </p>
          <a className="contact-action" href={`mailto:${EMAIL}`}>
            Send an email <FiArrowRight />
          </a>
        </article>
      </div>

      <div className="contact-banner">
        <div>
          <strong>Already using Nnetego?</strong>
          <span>Find the support contact for your country.</span>
        </div>
        <Link to="/support" className="button-primary">
          Support contacts
        </Link>
      </div>
    </PageLayout>
  </div>
);

export default ContactUsPage;
